<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconArrowLeftRegular_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="m1.254 8.619 4.334 4.375a.86.86 0 0 0 1.225 0 .88.88 0 0 0 0-1.237L4.016 8.933h10.106A.88.88 0 0 0 15 8.046a.88.88 0 0 0-.878-.887H3.926l2.887-2.915a.88.88 0 0 0 0-1.237.86.86 0 0 0-1.225 0L1.254 7.382a.88.88 0 0 0 0 1.237"
        clip-rule="evenodd"
    />
</svg>
